import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ condensed = false }) => {
 
  const condensedLegalLinks = [
    { name: "Terms", href: "/terms-and-conditions" },
    { name: "Privacy", href: "/privacy-policy" }
  ];

  // Full links
  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "Services", href: "services" },
    { name: "About Us", href: "about" },
    { name: "Contact", href: "contact" }
  ];
  const legalLinks = [
    { name: "Terms & Conditions", href: "/terms-and-conditions" },
    { name: "Privacy Policy", href: "/privacy-policy" }
  ];
  const services = [
    { name: "Real-Time Storage", href: "#" },
    { name: "Large-Item Delivery", href: "#" },
    { name: "Short-Distance Courier", href: "#" },
    { name: "Moving Support", href: "#" }
  ];

  // Social links (shared)
  const socialLinks = [
    { icon: "fab fa-facebook-f", href: "#" },
    { icon: "fab fa-twitter", href: "#" },
    { icon: "fab fa-instagram", href: "https://www.instagram.com/storage_sprint" },
    { icon: "fab fa-linkedin-in", href: "#" }
  ];

  if (condensed) {
    // Condensed Footer
    return (
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
             <div className="mb-4 md:mb-0 flex items-center space-x-2">
              <h3 className="text-xl font-bold">
                <span className="text-yellow-500">Storage</span>Sprint
              </h3>
            </div>
            <div className="flex flex-wrap justify-center gap-6 mb-4 md:mb-0">
              <div className="flex space-x-6">
                {quickLinks.map((link, index) => (
                  <Link 
                    key={index} 
                    to={link.href}
                    className="text-gray-400 hover:text-yellow-500 transition duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
              <div className="flex space-x-6">
                {condensedLegalLinks.map((link, index) => (
                  <Link 
                    key={index} 
                    to={link.href}
                    className="text-gray-400 hover:text-yellow-500 transition duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-yellow-500 transition duration-300"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
          <div className="pt-6 mt-6 border-t border-gray-700 text-center text-gray-400 text-sm">
            <p>&copy; {new Date().getFullYear()} Storage Sprint. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
  }

  // Full Footer
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              
              <h3 className="text-2xl font-bold">
                <span className="text-yellow-500">Storage</span>Sprint
              </h3>
            </div>
            <p className="text-gray-400">
              South Africa's premier on-demand storage and delivery service.
            </p>
            <div className="flex space-x-4 mt-6">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.href} 
                  className="text-gray-400 hover:text-yellow-500 transition duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith('/') ? (
                    <Link 
                      to={link.href}
                      smooth={true}
                      className="text-gray-400 hover:text-yellow-500 transition duration-300"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      href={`#${link.href}`}
                      className="text-gray-400 hover:text-yellow-500 transition duration-300"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <a 
                    href={service.href} 
                    className="text-gray-400 hover:text-yellow-500 transition duration-300"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              {legalLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.href} 
                    className="text-gray-400 hover:text-yellow-500 transition duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            </div>
        </div>
        <div className="pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Storage Sprint. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;